import React, { useCallback } from "react";
import styles from "./nodeTypeComponents.module.css";
import { LoadingOutlined } from "@ant-design/icons";
import { throttle } from "lodash";
export var LoadMore = function LoadMore(_ref) {
  var _ref$noMore = _ref.noMore,
    noMore = _ref$noMore === void 0 ? true : _ref$noMore,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  var handleClickLoadMore = useCallback(throttle(function () {
    onClick();
  }, 5000, {
    trailing: false
  }), [onClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.loadMore
  }, noMore ? /*#__PURE__*/React.createElement("div", null, "No more") : /*#__PURE__*/React.createElement("div", {
    onClick: handleClickLoadMore
  }, "Load more ", loading && /*#__PURE__*/React.createElement(LoadingOutlined, null)));
};